let execute = (text, blob,url, imageName) =>{

    const shareImg = new File([blob], `${imageName}.png`, {type: 'image/png'})
    navigator.share({
          text: text,
          url: url,
          files: [shareImg]
    })

}

let check =() =>{

  return navigator.share !== undefined;

}
let key = {};

export default {execute, check, key}
